import { render, staticRenderFns } from "./SucursalFactura.vue?vue&type=template&id=e20ffb1e"
import script from "./SucursalFactura.vue?vue&type=script&lang=js"
export * from "./SucursalFactura.vue?vue&type=script&lang=js"
import style0 from "./estilos_registro_programa.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports